'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

function defaultValueFormatter(value, state, options) {
  var format = state.format;

  if ((0, _lodash.isEmpty)(format) || (0, _lodash.isEmpty)(value)) return '--';

  return format.map(function (item) {
    var valueItem = value.find(function (val) {
      return val.name === item.name;
    });
    var itemValue = valueItem && valueItem.value;
    switch (item.type) {
      case 'label':
        return item.label;
      case 'select':
        return itemValue && (itemValue.text || itemValue.label);
      case 'input':
        return itemValue;
      default:
        return '';
    }
  }).join('');
}

exports.default = {
  defaultValueFormatter: defaultValueFormatter
};
module.exports = exports['default'];